import { SCENES } from '../config/constants';
import { getCarHoldMotion } from '../data/bossFinalCarMotion';
import { getBossFinalFrame } from '../data/bossFinalTimeline';
import { BossFinalScene } from './BossFinalScene';

/**
 * Tela de espera do telão depois do fechamento do Boss Final (RN-BF-051, RN-BF-058).
 *
 * Mostra o carro montado no `CAR_HOLD` com os mesmos insights da animação, com pneus
 * girando e oscilação de estrada (mesma regra de `BossFinalScene`, via `getCarHoldMotion`).
 * Só leitura: não tem transição de saída nem caminho para o jogo.
 */
export class TelaEsperaTelaoScene extends BossFinalScene {
    constructor () {
        super(SCENES.TELA_ESPERA_TELAO);
    }

    init (data = {}) {
        super.init(data);
        // Começa já no fim da animação: o quadro é sempre o CAR_HOLD.
        this.seekMs = getBossFinalFrame(0, this.insights.length).durationMs;
    }

    update (time) {
        const elapsed = time - this.startedAt;
        const frame = getBossFinalFrame(elapsed, this.insights.length);
        const { roadOffset, tireRotation } = getCarHoldMotion(elapsed - frame.durationMs);
        this.renderFrame(frame, roadOffset);
        this.tires.forEach((tire) => tire.setRotation(tireRotation));
    }

    replay () {}
}
